import { render, staticRenderFns } from "./closing-index.vue?vue&type=template&id=0b87b6d5"
import script from "./closing-index.vue?vue&type=script&lang=js"
export * from "./closing-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports